import {useStyles} from '../../../shared/hooks/styles';

export const GetStyles = () => {
  return useStyles(({theme}) => {
    return {
      action: {
        ...theme.fonts.h6Light,
      },
      actionExit: {
        marginLeft: 4,
      },
      fallbackContainer: {
        flexDirection: 'row',
        justifyContent: 'center',
        paddingVertical: 50,
      },
      menuContainer: {display: 'flex', marginTop: 8, flex: 1},
      row: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
      },
      column: {display: 'flex', flexDirection: 'column', alignItems: 'center'},
      smallButtonContainer: {
        marginTop: 14,
        paddingVertical: 8,
      },
      iconColor: {
        color: theme.color.textColor,
      },
      container: {
        paddingBottom: theme.screen.bottomOffset,
      },
    };
  });
};

export const GetMenuItemStyles = () => {
  return useStyles(({theme}) => ({
    menuElement: {
      display: 'flex',
      flexDirection: 'row',
      paddingHorizontal: 16,
      paddingVertical: 20,
      backgroundColor: theme.color.primaryNonGreyBackground,
      marginHorizontal: 16,
      marginVertical: 6,
      borderRadius: 14,
      justifyContent: 'space-between',
    },
    title: {
      flexGrow: 0,
      flexShrink: 1,
    },
    arrowColor: {
      color: theme.color.textColor,
    },
    arrow: {
      flexBasis: 24,
      flexGrow: 0,
      flexShrink: 0,
      height: theme.fonts.h6Light.lineHeight,
      justifyContent: 'center',
    },
  }));
};
